import { lightColorPalette } from '@linearb/linui-common';
import { SIZES, SPACES } from 'common/constants/sizes';
import { cssWhiteSection } from 'components/base/common-styles';
import styled from 'styled-components';

export const StyledHeaderImg = styled.img`
  margin-left: 1.5rem;
`;

export const StyledSettingHeader = styled.header`
  color: ${lightColorPalette.lbTextSubdued};
  font-size: 1.5rem;
  display: flex;
  align-items: center;
`;

export const StyledSettingBox = styled.div`
  font-size: ${SIZES.medium};
  & .MuiCheckbox-root {
    margin-left: -0.8rem;
  }
  & > section {
    display: flex;
    align-items: center;
  }
  &:not(:last-child) {
    margin-bottom: ${SPACES.medium};
    padding-bottom: ${SPACES.medium};
    border-bottom: 1px solid ${lightColorPalette.lbBlue_10};
  }
`;

export const StyledSettingsModal = styled.div`
  ${cssWhiteSection};
  box-sizing: border-box;
  padding: ${SPACES.medium};
  height: 100%;

  & > header {
    display: flex;
    align-items: center;
    font-size: ${SIZES['x-large']};
    & svg#PeopleClock {
      margin-right: 1rem;
    }
  }
  & > main {
    margin-top: ${SPACES.medium};
  }

  & > footer {
    box-sizing: border-box;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
  }
`;
